import React from 'react'
import { connect } from 'react-redux'
import Auth from '../../auth/Auth'
import { fetchAppContent } from '../../redux/actions/appContentActions'
import { fetchMemberSummary } from '../../redux/actions/memberSummaryActions'

class BaseComponent extends React.Component {
  componentDidMount () {
    // Fetch the initial app content. This will only happen once,
    // when the base component mounts during application launch.
    this.props.fetchAppContent()

    if (Auth.isAuthenticated) {
      this.props.fetchMemberSummary()
    }
  }

  render () {
    return this.props.children
  }
}

function mapStateToProps (state, ownProps) {
  return {
    appContent: state.AppContentReducer.appContent
  }
}

const ConnectedBaseComponent = connect(
  mapStateToProps,
  {
    fetchAppContent,
    fetchMemberSummary
  }
)(BaseComponent)

export default ConnectedBaseComponent



// WEBPACK FOOTER //
// ./src/components/base/index.js